import * as React from 'react';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider } from '@mui/x-date-pickers';
import Bs4GenericField from './Bs4GenericField';
import {isNullOrNaN} from '../../Bs4Components/Bs4Utils';
import Bs4ViewTime, {getFormatedTime} from '../../Bs4Components/Bs4ViewTime'
import Bs4MainDispatch from '../../Bs4MainDispatch';

export default class Bs4Time extends Bs4GenericField {

  static baseTime = new Date(0);

  atrybOnchange = Bs4GenericField.CHANGE_SELF;

  setValueBs4(value) {   
    value = (parseInt(value) || 0);
    this.setValue(value);
  }

  getValueBs4() {    
    const value = parseInt(this.getValue());
    if (isNullOrNaN(value)) return null;
    return value;
  }

  getShortValue(full) {    
    return getFormatedTime(this.getValue());    
  }

  ViewComponentField = (props) => {
    const formField = this;
    const [value, setValue] = React.useState(() => this.getValue());
    const [error, setError] = React.useState(Bs4GenericField.NO_ERROR)       

    this.refFocus = React.useRef();    

    const checkError = React.useCallback((value) => {
      if (isNullOrNaN(value)) return;
      // this.props.field.minValue = 4 * 60;
      // this.props.field.maxValue = 200 * 60;
      const seconds = parseInt(value);
      const minValue = parseInt(this.props.field.minValue);
      const maxValue = parseInt(this.props.field.maxValue);
      if (!isNullOrNaN(minValue) && seconds < minValue) {
        setError({error: true, helperText: getFormatedTime(seconds)+' < '+getFormatedTime(minValue)});    
      } else if (!isNullOrNaN(maxValue) && seconds > maxValue) {
        setError({error: true, helperText: getFormatedTime(seconds)+' > '+getFormatedTime(maxValue)});
      } else setError(Bs4GenericField.NO_ERROR);
    }, [this.props.field, setError]);

    React.useEffect(() => {
      checkError(this.getValue());
      this.notValidElementDom = (text) => {setError({error: true, helperText: text})}
      this.on(Bs4GenericField.CHANGE, (field, oldValue, newValue) => {
        const value = this.getValue();
        setValue(value);
        checkError(value);
      })    
    }, [setError, checkError]);

    const handleChange = (newValue) => {
      const seconds = newValue;
      this.setValue(seconds);
      //if (isNaNnull(seconds)) return;
      checkError(seconds);
    }

    const handleOpen = (event) => {
      this.trigger(Bs4GenericField.FOCUS_ENTER, this);
    }

    const handleClose = (event) => {
      this.trigger(Bs4GenericField.FOCUS_LEAVE, this);
      this.trigger(Bs4GenericField.CHANGE_SELF, this);
    }

    const [xx, xxXX, pl] = Bs4MainDispatch.useBs4Locale();

    return (
      <LocalizationProvider 
        dateAdapter={AdapterDateFns}  
        adapterLocale={pl}         
        localeText={xxXX.components.MuiLocalizationProvider.defaultProps.localeText}
      >
        <Bs4ViewTime
          bs4kartotekaid={formField.bs4KartotekaId}
          inputRef={formField.refFocus}
          readOnly={formField.readOnly}
          fullWidth={true}          
          label={<formField.Bs4Label/>}
          error={error.error}
          helperText={error.helperText}          
          timeStep={parseInt(formField.props.field.min_interval) || 5} 
          InputLabelProps={formField.props.field.hideLabel ? {sx:{display:'none'}} : null}
          value={value}
          ampm={false}
          onChange={handleChange}    
          onOpen={handleOpen}
          onClose={handleClose}      
          hoursMin={formField.props.field.hours_min || null}
          hoursMax={formField.props.field.hours_max || null}
        />
      </LocalizationProvider>
    );
  }
}